import { render, staticRenderFns } from "./MarryPlan.vue?vue&type=template&id=fab81694&scoped=true&"
import script from "./MarryPlan.vue?vue&type=script&lang=js&"
export * from "./MarryPlan.vue?vue&type=script&lang=js&"
import style0 from "./MarryPlan.vue?vue&type=style&index=0&id=fab81694&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab81694",
  null
  
)

export default component.exports